const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

export const api = async (path, { method = "GET", body, token } = {}) => {
  const authToken = token || localStorage.getItem("token");

  const res = await fetch(`${API_URL}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
    },
    credentials: "include",
    body: body ? JSON.stringify(body) : undefined,
  });

  let data;
  try {
    data = await res.json();
  } catch {
    data = {};
  }

  if (!res.ok) {
    throw new Error(data.message || res.statusText);
  }

  return data;
};
